/* eslint-disable react/prop-types */
import React from "react";
import { format } from "date-fns";
import AvailabilitySlot from "./AvailabilitySlot";

function DayAvailability({
  date,
  dayData,
  filters,
  showAllSlots,
  selectedSlot,
  onSlotClick,
  isUrgentDay,
  appointmentData,
}) {
  const formattedDate = format(date, "yyyy-MM-dd");
  const dayOfWeek = format(date, "EEEE");
  const lowercaseDayOfWeek = dayOfWeek ? dayOfWeek.toLowerCase() : "";
  const hasRecommendedSlot = dayData?.AM?.recommended || dayData?.PM?.recommended;

  const showAM = filters.period === "all" || filters.period === "am";
  const showPM = filters.period === "all" || filters.period === "pm";

  const today = new Date();
  const past8AM = today.getHours() > 8;

  const isToday =
    today.getDate() === date.getDate() && today.getMonth() === date.getMonth();
  const slotIsTodayAndpast8AM = isToday && past8AM;

  if (!showAllSlots && !hasRecommendedSlot && !isUrgentDay) {
    return null;
  }

  if (filters.dayOfWeek !== "all" && filters.dayOfWeek !== lowercaseDayOfWeek) {
    return null;
  }

  return (
    <li className={`day-card ${hasRecommendedSlot ? "has-recommended" : ""}`}>
      <div className="slots-container">
        <p className="slots-container-date">
          {format(date, "EEEE, MMMM d, yyyy")}
        </p>
        {!slotIsTodayAndpast8AM && showAM && (
          <AvailabilitySlot
            slot={dayData.AM}
            date={date}
            formattedDate={formattedDate}
            period="AM"
            showAllSlots={showAllSlots}
            selectedSlot={selectedSlot}
            onSlotClick={onSlotClick}
            isUrgentDay={isUrgentDay}
            appointmentData={appointmentData}
          />
        )}
        {showPM && (
          <AvailabilitySlot
            slot={dayData.PM}
            date={date}
            formattedDate={formattedDate}
            period="PM"
            showAllSlots={showAllSlots}
            selectedSlot={selectedSlot}
            onSlotClick={onSlotClick}
            isUrgentDay={isUrgentDay}
            appointmentData={appointmentData}
          />
        )}
      </div>
    </li>
  );
}

export default DayAvailability;
